import { Component, OnInit } from '@angular/core';
import { CoreService } from "../core.service";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import {UserRolePermissionsService} from "../user-role-permissions.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SystemHealthModalComponent} from "../SystemHealthModal/system-health-modal.component";

@Component({
    selector: 'app-busy',
    templateUrl: './busy.component.html',
    styleUrls: ['./busy.component.css'],
    imports: [
        TranslateModule,
        CommonModule,
    ],
    standalone:true
})
export class BusyComponent implements OnInit {

    constructor(
        public core: CoreService,
        private modalService: NgbModal,
        public userRolePermissionsService: UserRolePermissionsService) { }

    public isBusy() { return this.core.isBusy(); }

    public ngOnInit() {
    }

    openMethodList() {
        if(!this.userRolePermissionsService.isAdminOrConsultant()){
            return;
        }

        SystemHealthModalComponent.Open(this.modalService);
    }
}
